import React from "react";
import { cn } from "./cn";

export type TruncatedTextProps = {
  text: string;
  lines?: number;
  className?: string;
};

export function TruncatedText({ text, lines = 1, className }: TruncatedTextProps) {
  return (
    <span
      className={cn(
        "block min-w-0",
        lines === 1 ? "truncate" : lines === 2 ? "line-clamp-2" : `line-clamp-${lines}`,
        className,
      )}
    >
      {text}
    </span>
  );
}
